import { Box, styled, Typography } from '@mui/material';
import CustomContainer from '../../singleComponents/grids/Container';
import InputSimple from '../../textInputs/InputSimple/InputSimple';

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '0 20px',
  height: '100vh',
  [theme.breakpoints.up('md')]: {
    justifyContent: 'center',
    margin: '0 auto',
  },
}));

export const SubtitleStyled = styled(Typography)({
  marginBottom: '23px',
});

export const Input2Styled = styled(InputSimple)({
  marginBottom: '40px',
  padding: '0',
  '& span': {
    margin: '0',
    position: 'relative',
    width: '56px',
  },
});

export const LinkContainerStyled = styled(CustomContainer)({
  marginTop: '16px',
});
